import { Box, Button, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { IconAlertTriangle, IconLogout, IconRefresh } from "@tabler/icons-react";
import { repair } from "@/utils/auth/repair";

export default function ErrorFallback() {
	return (
		<Stack h="100vh" justify="center" align="center" p="md">
			<ThemeIcon variant="transparent" size={64} color="red">
				<IconAlertTriangle style={{ width: "100%", height: "100%" }} />
			</ThemeIcon>

			<Title ta="center" order={1}>
				Ha ocurrido un error inesperado
			</Title>

			<Text ta="center" size="lg" maw={480}>
				Puedes intentar recargar la página o cerrar sesión para limpiar los datos.
			</Text>

			<Box>
				<Stack align="center">
					<Button
						size="lg"
						leftSection={<IconRefresh />}
						onClick={() => window.location.reload()}
					>
						Recargar
					</Button>

					<Button
						variant="subtle"
						color="red"
						leftSection={<IconLogout />}
						onClick={() => repair()}
					>
						Cerrar sesión y reparar
					</Button>
				</Stack>
			</Box>
		</Stack>
	);
}
